import { areDescriptionsEqual } from "../helpers";
import { IndustrialProcessSchema, IndustrialProcessType } from "../types";

export const getProcessStepDescriptionFromCompanyMachine = (cm: {
  machine: {
    name: string;
  };
  processStepDescriptionOverride?: string | null;
}): string | null => {
  return cm.processStepDescriptionOverride || cm.machine.name;
};

export const getRelevantMachine = <
  T extends {
    machine: { industrialProcess: IndustrialProcessType; name: string };
    machineHourlyPrice: number;
    modelProcessStepDescription?: string | null;
    processStepDescriptionOverride?: string | null;
  },
>(
  companyMachines: T[],
  industrialProcess: IndustrialProcessType,
  modelProcessStepDescription?: string | null,
): T | null => {
  if (companyMachines.length === 0) {
    return null;
  }

  const relevantCompanyMachines = companyMachines
    .filter((companyMachine) => companyMachine.machine.industrialProcess === industrialProcess)
    .sort((a, b) => b.machineHourlyPrice - a.machineHourlyPrice);

  if (relevantCompanyMachines.length === 0) {
    return null;
  }

  const machineWithDescriptionMatch = relevantCompanyMachines.find((cm) => {
    const isProcessStepFromModel = areDescriptionsEqual(
      cm.modelProcessStepDescription,
      modelProcessStepDescription,
    );
    const isProcessStepFromManualSetup = areDescriptionsEqual(
      getProcessStepDescriptionFromCompanyMachine(cm),
      modelProcessStepDescription,
    );

    return isProcessStepFromModel || isProcessStepFromManualSetup;
  });

  if (industrialProcess !== IndustrialProcessSchema.enum.OTHER) {
    return machineWithDescriptionMatch || relevantCompanyMachines[0]!;
  }

  if (!modelProcessStepDescription || modelProcessStepDescription.length === 0) {
    return null;
  }

  return machineWithDescriptionMatch || null;
};
